import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import {
  initConsent,
  setConsent,
  CONSENT_ACCEPTED,
  CONSENT_REJECTED,
} from 'utils/cookieConsent';
import css from './css.module.scss';

const CookieConsent = () => {
  const [t] = useTranslation('global');
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Restore the previous decision (load/block GTM) and only prompt when the
    // user has not made a choice yet.
    if (!initConsent()) {
      setVisible(true);
    }
  }, []);

  const handleChoice = (value) => {
    setConsent(value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <aside
      className={css.banner}
      role="dialog"
      aria-live="polite"
      aria-label={t('cookies.title')}
    >
      <div className={css.content}>
        <div className={css.text}>
          <h4 className={css.title}>{t('cookies.title')}</h4>
          <p className={css.description}>{t('cookies.description')}</p>
        </div>

        <div className={css.actions}>
          <button
            type="button"
            className={clsx(css.button, css.reject)}
            onClick={() => handleChoice(CONSENT_REJECTED)}
          >
            {t('cookies.reject')}
          </button>
          <button
            type="button"
            className={clsx(css.button, css.accept)}
            onClick={() => handleChoice(CONSENT_ACCEPTED)}
          >
            {t('cookies.accept')}
          </button>
        </div>
      </div>
    </aside>
  );
};

export default CookieConsent;
